// assets/product-list.js

document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll(".section-product-list");
  if (sections) {
    sections.forEach(function (section) {
      var elId = null;
      if (section && section.id) {
        elId = section.id;
      }
      var el = null;
      if (elId) {
        el = document.getElementById(elId);
      }
      if (el) {
        el.addEventListener("click", function (e) {
          if (
            e &&
            e.target &&
            e.target.classList &&
            e.target.classList.contains("product-tab-label")
          ) {
            var tabContents = el.querySelectorAll(".product-tab-content");
            if (tabContents) {
              tabContents.forEach(function (tabContent) {
                if (tabContent) {
                  tabContent.classList.add("hide");
                }
              });
            }
            var tabTitle = el.querySelector(".product-tab-title");
            if (
              tabTitle &&
              e.target &&
              e.target.dataset &&
              e.target.dataset.title
            ) {
              tabTitle.innerText = e.target.dataset.title;
            }
            if (e.target && e.target.dataset && e.target.dataset.content) {
              var contentEl = el.querySelector("#" + e.target.dataset.content);
              if (contentEl) {
                contentEl.classList.remove("hide");
              }
            }
          }
        });
      }
    });
  }

  function initProductLists() {
    var productLists = document.querySelectorAll(
      ".section-product-list .swiper"
    );
    if (productLists) {
      productLists.forEach(function (pl, index) {
        var SwiperConstructor = Swiper;
        if (typeof SwiperConstructor !== "function") {
          return;
        }
        var swiperIndex = index + 1;
        var swiperInstance = new SwiperConstructor(pl, {
          slidesPerView: 1.3,
          slidesPerColumn: 1,
          breakpoints: {
            768: {
              slidesPerView: 2.5,
            },
            1024: {
              slidesPerView: 4,
              navigation: {
                nextEl: ".swiper-nav" + swiperIndex + " .swiper-button-next",
                prevEl: ".swiper-nav" + swiperIndex + " .swiper-button-prev",
              },
            },
          },
          on: {
            init: function () {
              var slides = this.slides;
              if (
                slides &&
                slides.length > 0 &&
                this.navigation &&
                this.navigation.prevEl &&
                this.navigation.nextEl
              ) {
                var img = slides[0].querySelector("img");
                if (img) {
                  var imgWidth = img.clientWidth / 2;
                  this.navigation.prevEl.style.top = imgWidth + "px";
                  this.navigation.nextEl.style.top = imgWidth + "px";
                }
              }
            },
            resize: function () {
              var slides = this.slides;
              if (
                slides &&
                slides.length > 0 &&
                this.navigation &&
                this.navigation.prevEl &&
                this.navigation.nextEl
              ) {
                var img = slides[0].querySelector("img");
                if (img) {
                  var imgWidth = img.clientWidth / 2;
                  this.navigation.prevEl.style.top = imgWidth + "px";
                  this.navigation.nextEl.style.top = imgWidth + "px";
                }
              }
            },
          },
        });
      });
    }
  }
  initProductLists();
});
